const KNOWN_ABBREVIATIONS = new Set([
  "API",
  "AWS",
  "ARN",
  "BSWL",
  "DB",
  "DNS",
  "DLQ",
  "ETL",
  "GCP",
  "GPU",
  "HPA",
  "HTTP",
  "IAM",
  "ID",
  "IP",
  "NEG",
  "URL",
  "URI",
  "VPC",
  "SASL",
  "SHA",
]);

export const uppercaseAbbreviations = (str: string): string => {
  if (KNOWN_ABBREVIATIONS.has(str.toUpperCase())) {
    return str.toUpperCase();
  }

  return str;
};

export const titleCase = (str: string): string => {
  if (str.length <= 1 || KNOWN_ABBREVIATIONS.has(str.toUpperCase())) {
    return str.toUpperCase();
  }

  return str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
};

export const titleCaseMultipleWords = (str: string): string =>
  str
    .split(/\s+/)
    .map((word) => titleCase(word))
    .join(" ");

export const capitalizeFirst = (str: string): string => {
  return str.length > 1 ? str.slice(0, 1).toUpperCase() + str.slice(1) : str.toUpperCase();
};

export const lowercaseFirst = (str: string): string => {
  return str.length > 1 ? str.slice(0, 1).toLowerCase() + str.slice(1) : str.toLowerCase();
};

export const protobufNameToWords = (name: string): string => {
  const truncated = name.replaceAll("HEALTH_CHECK_NAME_", "");
  return snakeCaseToWords(truncated);
};

export const snakeCaseToWords = (snake: string, capitalizeOnlyFirst?: boolean): string => {
  return snake
    .split(/[\s_]+/g)
    .map((l, idx) =>
      l ? (!capitalizeOnlyFirst || idx === 0 ? titleCase(l) : uppercaseAbbreviations(l)) : "",
    )
    .join(" ");
};

export const camelCaseToWords = (camel: string, capitalizeOnlyFirst?: boolean): string => {
  const words = camel.replace(/[A-Z][a-z]+/g, (word) => {
    return ` ${word}`;
  });

  return words
    .split(" ")
    .map((word, idx) =>
      idx === 0 || !capitalizeOnlyFirst ? titleCase(word) : uppercaseAbbreviations(word),
    )
    .join(" ");
};

export const camelCaseToKebab = (camel: string): string => {
  return camel.replace(/[A-Z][a-z]*/g, (word) => {
    return `-${word.toLowerCase()}`;
  });
};

export const camelCaseToSnakeCase = (camel: string): string => {
  return camel.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

export const wordsToSnakeCase = (words: string) =>
  words.toLowerCase().replace(/\W+/g, " ").trim().replaceAll(" ", "_");

export const wordsToKebabCase = (words: string) =>
  words.toLowerCase().replace(/\W+/g, " ").trim().replaceAll(" ", "-");

export const snakeToTitleCase = (snake: string, capitalizeOnlyFirst?: boolean): string =>
  snake
    .split("_")
    .map((l, idx) =>
      l ? (!capitalizeOnlyFirst || idx === 0 ? titleCase(l) : uppercaseAbbreviations(l)) : "",
    )
    .join("");
